<template>
  <div>
 
    <span class="connect_btn"  @click="handleAuthClick()">Connect to Google Drive</span>

    <div id="content"></div>

  </div>
</template>

<script>
import mime from 'mimetype';
export default {
  data() {
    return {
      access_token:'',
      filesUploading:false,
    }
  },
  methods: {
    async createPicker() {
        var $self = this;
   const view = new google.picker.View(google.picker.ViewId.DOCS);
    view.setMimeTypes();
    const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setDeveloperKey(API_KEY)
        .setAppId(APP_ID)
        .setOAuthToken(accessToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setCallback($self.pickerCallback)
        .build();
    picker.setVisible(true);
    },
 async pickerCallback(data) {
  let self = this;
  self.filesUploading = true;
  let access_Token = this.access_token;
  let blobFiles = [];
   console.log(JSON.stringify(data))
    if (data.action === google.picker.Action.PICKED) {
      if(data && data['docs'] && data['docs'].length>0){
        let googleDriveFiles = _.cloneDeep(data['docs']);
        self.filesUploading = true;
        _.forEach(googleDriveFiles, (obj)=>{
          if((_.has(obj, 'link') && obj['link']) || true){
            let downloadUrl = `https://www.googleapis.com/drive/v3/files/${obj['id']}?alt=media`;
            fetch(downloadUrl,{
              method: 'GET',
              headers: {
                'Authorization': 'Bearer ' + access_Token,
              },
            })
            .then(response => {
              return response.blob(); // Convert the response to a Blob
            })
            .then(blob => {
              console.log(blob);
              let item = {};
              if(_.has(obj, 'name') && obj['name']){
                item['name'] = obj['name']; 
                let mimetype = mime.lookup(obj.name);
                if(mimetype){
                  item.mimetype =mimetype;
                }
              }
              item['file'] = blob;
              item['path'] = '';
              item['isNew'] = true;
              item['status'] = true;
              item['uploadedBy']= self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null
              item['uploadedByName']= self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):''
              item['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null
              item['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName')
              blobFiles.push(item)
              if(data['docs'] && blobFiles &&  (data['docs'].length == blobFiles.length)){
                console.log(JSON.stringify(blobFiles));
                this.$emit('emitBlobFiles', blobFiles )
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        })
      }
      
    }
  },
    handleAuthClick() {
    if(tokenClient){
          tokenClient.callback = async (response) => {
      if (response.error !== undefined) {
        throw (response);
      }
      accessToken = response.access_token;
      this.access_token = accessToken
   
      await this.createPicker();
    };

    if (accessToken === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      tokenClient.requestAccessToken({prompt: ''});
    }

    }
   
    },
  },
  mounted() {

  },
  props:{
    docAcceptType:{
      type:String,
        default:'image/png,image/jpeg,image/jpg,image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
  }
}
</script>
